import isEmpty from 'lodash/isEmpty'

export default function getDataAttribute(identificator, data_suffix) {

  let value = null,
      data  = `data-${data_suffix}`

  try {
    value = document.getElementById(identificator).getAttribute(data)

    if( isEmpty(value) ) {
      return "UNKNOWN";
    }

    return value;

  } catch (error) {
    console.log(error)
  }
}
